module.exports = __webpack_public_path__ + "img/6.5.COD.9c78f31a.png";